import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { MARKED_OPTIONS, MarkedOptions, MarkedRenderer, provideMarkdown } from 'ngx-markdown';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { I18nService } from './core/services';

function translationInitializer(): Promise<unknown> {
  const translate = inject(TranslateService);
  translate.setFallbackLang('nl');
  return firstValueFrom(translate.use('nl'));
}

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  const renderLink = renderer.link;

  renderer.link = function (token) {
    return renderLink.call(this, token).replace(
      '<a ',
      '<a target="_blank" rel="noopener noreferrer" ',
    );
  };

  return {
    renderer,
    gfm: true,
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: markedOptionsFactory,
      },
    }),
    provideTranslateService({
      lang: 'nl',
      fallbackLang: 'nl',
      loader: { provide: TranslateLoader, useExisting: I18nService },
    }),
    provideAppInitializer(translationInitializer),
  ],
};
